import { LogisticBoxView, MainTab, Tone, ToneKey } from './models'

export const VIEWS: { key: MainTab, label: string }[] = [
  { key: 'dashboard', label: 'Principal' },
  { key: 'etiquetas', label: 'Recolecciones' },
  // { key: 'tracking', label: 'Tracking' }, // fusionado dentro de "Recolecciones" (botón "Ver tracking" por fila)
  { key: 'insumos', label: 'Insumos' }
  // { key: 'reglas', label: 'Reglas' },        // oculto en la app de tiendas · vive en arrivals (admin Reuse)
  // { key: 'discrepancias', label: 'Arribos' },  // oculto en la app de tiendas · vive en arrivals (admin Reuse)
  // { key: 'incumplimientos', label: 'Atrasos' } // tab oculto · la vista se conserva
]

// Cada vista (incl. sub-vistas) se asocia a un tab principal para mantener
// resaltado el tab padre mientras se navega un detalle.
export const PARENT_TAB: Record<LogisticBoxView, MainTab> = {
  dashboard: 'dashboard',
  etiquetas: 'etiquetas',
  // tracking: 'tracking', // tab "Tracking" comentado · fusionado en "Recolecciones"
  insumos: 'insumos',
  incumplimientos: 'incumplimientos',
  reglas: 'reglas',
  discrepancias: 'discrepancias',
  'detalle-tienda': 'dashboard',
  'tienda-atrasada': 'incumplimientos',
  // 'todas-solicitudes': 'insumos', // sub-vista comentada · solicitudes paginadas dentro de Insumos
  'todos-envios': 'insumos',
  'todo-inventario': 'insumos',
  'todas-automaticas': 'insumos',
  'tracking-insumos': 'insumos',
  'envio-detalle': 'etiquetas',
  'recepcion-detalle': 'discrepancias',
  // El tracking de una recolección mantiene resaltado el tab "Recolecciones"
  'recoleccion-tracking': 'etiquetas',
  // La hoja de ruta de recolecciones internas también cuelga de "Recolecciones"
  'recolecciones-internas': 'etiquetas',
  // El reparto interno de insumos cuelga del tab "Insumos"
  'reparto-interno': 'insumos'
}

// Safety stock por tienda (mínimos que gatillan reposición automática)
export const SAFETY = {
  cajas: 2,
  bolsasA: 50,
  bolsasB: 30,
  sellos: 20
}

// Nombre del courier según el país del despliegue (VITE_COURIER_NAME):
//   MX = DHL · CL = Blue Express · PE = pendiente (aún por definir).
// Se usa en todos los textos visibles que antes decían "DHL".
export const COURIER = ((import.meta.env.VITE_COURIER_NAME as string | undefined) ?? 'DHL').trim() || 'DHL'

// País del despliegue (VITE_COUNTRY: MX | CL | PE).
export const COUNTRY = ((import.meta.env.VITE_COUNTRY as string | undefined) ?? '').trim().toUpperCase()

// Término para la etiqueta de recolección según el país: en MX se le llama
// "Guía"; en el resto "Etiqueta". Capitalizado y en minúscula para usar en frases.
export const TERMINO_ETIQUETA = COUNTRY === 'MX' ? 'Guía' : 'Etiqueta'
export const TERMINO_ETIQUETA_LOWER = COUNTRY === 'MX' ? 'guía' : 'etiqueta'

// Paleta pastel + ink, alineada con la maqueta. Se usa como
// `style={{ background: TONES.green.bg }}` o vía clases inline.
export const TONES: Record<ToneKey, Tone> = {
  lila:  { bg: '#ede9fe', ink: '#7c3aed', bgSoft: 'rgba(237,233,254,0.4)', bar: '#7c3aed' },
  rosa:  { bg: '#FAECE7', ink: '#993C1D', bgSoft: 'rgba(250,236,231,0.4)', bar: '#993C1D' },
  amber: { bg: '#FEF3C7', ink: '#92400E', bgSoft: 'rgba(254,243,199,0.5)', bar: '#d97706' },
  green: { bg: '#EAF3DE', ink: '#3B6D11', bgSoft: 'rgba(234,243,222,0.4)', bar: '#3B6D11' },
  blue:  { bg: '#E6F1FB', ink: '#185FA5', bgSoft: 'rgba(230,241,251,0.4)', bar: '#185FA5' },
  beige: { bg: '#f5f5f4', ink: '#78716c', bgSoft: 'rgba(245,245,244,0.4)', bar: '#a8a29e' },
  teal:  { bg: '#E0F2F1', ink: '#0F766E', bgSoft: 'rgba(224,242,241,0.4)', bar: '#0F766E' }
}

export const FOUNDATION = '#151930'
export const SOLID = '#37417f'
export const ACCENT = '#c6ffad'
export const LILAC = '#afb9ff'

export const DAY_NAMES = ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb']

// Las recolecciones se gatillan por evento o cron, no por día fijo.
// El calendario ahora muestra un resumen de actividad por fecha.
export const CYCLE_BY_DAY: Record<number, { tag: string, tone: ToneKey | 'gray', view: LogisticBoxView, note: string }> = {
  1: { tag: 'Resumen', tone: 'gray', view: 'dashboard', note: 'Ver actividad del día' },
  2: { tag: 'Resumen', tone: 'gray', view: 'dashboard', note: 'Ver actividad del día' },
  3: { tag: 'Resumen', tone: 'gray', view: 'dashboard', note: 'Ver actividad del día' },
  4: { tag: 'Resumen', tone: 'gray', view: 'dashboard', note: 'Ver actividad del día' },
  5: { tag: 'Resumen', tone: 'gray', view: 'dashboard', note: 'Ver actividad del día' },
  6: { tag: 'Resumen', tone: 'gray', view: 'dashboard', note: 'Ver actividad del día' },
  0: { tag: 'Resumen', tone: 'gray', view: 'dashboard', note: 'Ver actividad del día' }
}
